export default "__VITE_ASSET__BWFRe$cL__"